export default "__VITE_ASSET__BgvHWYsy__"